/* @flow */
import React, { Component } from 'react';
import find from 'lodash/find';

type Props = {
    social: Array<any>,
};

class SocialLogin extends Component<Props> {
    render() {
        const facebookObj =
            this.props.social &&
            find(this.props.social, item => {
                return item.facebook;
            });
        const googleObj =
            this.props.social &&
            find(this.props.social, item => {
                return item.google;
            });
        const twitterObj =
            this.props.social &&
            find(this.props.social, item => {
                return item.twitter;
            });

        return (
            <section id="inpx-social">
                <div className="socialoptions">
                    {facebookObj !== undefined && (
                        <a href={facebookObj.facebook} className="suw-facebook">
                            <i className="ipic_soc-facebook" />
                            <span className="liwsoc">
                                <span />CONTINUE WITH FACEBOOK
                            </span>
                        </a>
                    )}
                    {googleObj && (
                        <a href={googleObj.google} className="suw-google">
                            <i className="ipic_soc-google">
                                <span className="path1" />
                                <span className="path2" />
                                <span className="path3" />
                                <span className="path4" />
                            </i>
                            <span className="liwsoc">
                                <span />SIGN IN WITH GOOGLE
                            </span>
                        </a>
                    )}
                    {twitterObj && (
                        <a href={twitterObj.twitter} className="suw-twitter">
                            <i className="ipic_soc-twitter" />
                            <span className="liwsoc">
                                <span />SIGN IN WITH TWITTER
                            </span>
                        </a>
                    )}
                </div>
            </section>
        );
    }
}

export default SocialLogin;



// WEBPACK FOOTER //
// ./src/ui/components/Forms/SocialLogin.js